<div class="row">
  <div class="col-lg-3 col-md-5 col-sm-12 col-12 pe-1 mb-2 mb-md-0  ">
    <div class="container-style">
      <div class="p-2 mb-2 d-flex justify-content-between align-items-center border-bottom">
        <span class="fw-bold">Soluciones <p-badge severity="secondary" [value]="quotationDetails.length" /></span>
        <div class="d-flex gap-1">
          <app-custom-button [title]="'Copiar Solución'" [severity]="'contrast'" [icon]="'pi pi-copy'"
            [disabled]="!quotationVersionContract.active || quotationContract.quotationId === 0"
            (onClick)="openCopyQuotation()"></app-custom-button>
          <app-custom-modal #copyQuotation [label]="'Copiar Solución'" [header]="'Copiar Solución'"
            [children]="componentCopyQuotation" [inputs$]="inputsForCopy$" [output$]="outputCopy$" [width]="'90vw'"
            hidden></app-custom-modal>

          <app-custom-button [icon]="'pi pi-plus'" [title]="'Nuevo'" [label]="'Nuevo'" [severity]="'success'"
            [disabled]="!quotationVersionContract.active || quotationContract.quotationId === 0" (onClick)="
            createNewSolution()"></app-custom-button>
        </div>
      </div>
      <div class="list-group list-group-flush">
        @for (detail of quotationDetails; track detail.quotationDetailId) {
        <button class="list-group-item list-group-item-action border-0 mb-1"
          [class.active-item]="selectedQuotationDetail.quotationDetailId === detail.quotationDetailId"
          (click)="quotationDetailSelected(detail)">
          <div class="d-flex justify-content-between align-items-center">
            <span class="fw-bold text-uppercase">
              {{ detail.solutionCode}} - {{getSolutionName(detail.solutionName)}}
            </span>
            <p-button *ngIf="quotationVersionContract.active" class="icon-list" icon="pi pi-trash" [text]="true"
              size="small" title="Eliminar" (onClick)="deleteSolution(detail.swBreakdown)" />
          </div>
          <div class="d-flex justify-content-between align-items-center">
            <small class="text-muted">{{
              detail.costCenterId != null ? detail.costCenterCodeName : 'Sin centro de costo'
              }}
            </small>
            <span class="fw-bold"> {{ (detail.totalValue + detail.ivaValue) | number:'1.2-2'}}</span>
          </div>
        </button>
        }
      </div>

    </div>
  </div>
  <div class="col-lg-9 col-md-7 col-sm-12 col-12 ps-1">
    <div class="container-style">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12">
          <div class="p-2 mb-2 d-flex justify-content-between align-items-center border-bottom">
            <span class="fw-bold">Datos de la solución </span>
            <div *ngIf="quotationDetails.length > 0" class="d-flex gap-1">
              <app-custom-button [title]="'Importar Despiece'" [severity]="'contrast'" [icon]="'pi pi-file-import'"
                [disabled]="!quotationVersionContract.active || quotationContract.quotationId === 0 || selectedQuotationDetail.quotationDetailId === 0"
                (onClick)="openImportBreakdown()"></app-custom-button>
              <app-custom-modal #importBreakdown [label]="'Seleccionar'" [header]="'Importar Despiece'"
                [children]="componentImportBreakdown" [inputs$]="inputsForImport$" [output$]="outputImport$"
                [width]="'40vw'" [breakpoints]="breakpointsForImport" hidden></app-custom-modal>

              <app-custom-button [title]="'Artículos Compuestos'" [severity]="'contrast'" [icon]="'pi pi-file-plus'"
                [disabled]="!quotationVersionContract.active || quotationContract.quotationId === 0 || selectedQuotationDetail.quotationDetailId === 0"
                (onClick)="openCompositeArticle()"></app-custom-button>
              <app-custom-modal #compositeArticle [label]="'Artículos Compuestos'" [header]="'Artículos Compuestos'"
                [children]="componentCompositeArticle" [width]="'70vw'" hidden
                [inputs$]="inputsForMasterSolution$" [output$]="outputMasterSolution$"></app-custom-modal>

              <app-custom-button [title]="'Adjuntar Imágenes'" [severity]="'contrast'" [icon]="'pi pi-paperclip'"
                [disabled]="quotationContract.quotationId === 0 || selectedQuotationDetail.quotationDetailId === 0"
                (onClick)="openAttachImages()"></app-custom-button>
              <app-custom-modal #attachImages [label]="'Adjuntar Imágenes'" [header]="'Adjuntar Imágenes'"
                [children]="componentAttachImages" [inputs$]="inputsForAttachImages$" [output$]="outputAttachImages$"
                [width]="'60vw'" hidden></app-custom-modal>

            </div>
          </div>
          <form *ngIf="quotationDetails.length > 0" [formGroup]="formQuotationSolution">
            <div class="row">
              <div class="col-lg-5 col-md-4 col-sm-6 col-12">
                <app-custom-autocomplete formControlName="costCenterId" [labelText]="'Centro Costos'"
                  [list]="listCostCenters" (onChangeSelect)="getCostCenter($event)">
                </app-custom-autocomplete>
              </div>
              <div class="col-lg-2 col-md-4 col-sm-6 col-12">
                <app-custom-input-text formControlName="solutionCode" [labelText]="'Solución'" [required]="true">
                </app-custom-input-text>
              </div>
              <div class="col-lg-5 col-md-4 col-sm-6 col-12">
                <app-custom-textarea formControlName="solutionName" [labelText]="'Nombre Solución'" [autoResize]="false" [rows]="1">
                </app-custom-textarea>
              </div>
              <div class="col-lg-2 col-md-4 col-sm-6 col-12">
                <app-custom-select formControlName="baseValue" [labelText]="'Valor Base'" [required]="true"
                  [list]="listBaseValue" (onChangeSelect)="getBaseValue($event)"></app-custom-select>
              </div>
              <div class="col-lg-2 col-md-4 col-sm-6 col-12">
                <app-custom-select formControlName="unitId" [labelText]="'Unidad'" [required]="true"
                  [list]="listUnits"></app-custom-select>
              </div>
              <div class="col-lg-2 col-md-4 col-sm-6 col-12">
                <app-custom-input-decimal formControlName="unitValue" [labelText]="'Vr.Unitario'" [required]="true"
                  [disabled]="true" (onChangeNumber)="getUnitValue($event)"></app-custom-input-decimal>
              </div>
              <div class="col-lg-1 col-md-2 col-sm-3 col-12">
                <app-custom-input-decimal formControlName="quantity" [labelText]="'Cantidad'" [required]="true"
                  (onChangeNumber)="getQuantity($event)"></app-custom-input-decimal>
              </div>
              <div class="col-lg-2 col-md-4 col-sm-6 col-12">
                <app-custom-input-decimal formControlName="subtotalValue" [labelText]="'Vr.Subtotal'" [required]="true"
                  [disabled]="true" (onChangeNumber)="getSubtotalValue($event)"></app-custom-input-decimal>
              </div>
              <div class="col-lg-1 col-md-2 col-sm-3 col-12">
                <app-custom-input-number formControlName="days" [labelText]="'Días'" [required]="true"
                  (onChangeNumber)="calculateTotalsValue()"></app-custom-input-number>
              </div>
              <div class="col-lg-2 col-md-4 col-sm-6 col-12">
                <app-custom-input-decimal formControlName="ivaRate" [labelText]="'% IVA'" [required]="true"
                  (onChangeNumber)="calculateTotalsValue()"></app-custom-input-decimal>
              </div>
              <div class="col-lg-2 col-md-4 col-sm-6 col-12 d-flex align-items-end mt-2">
                <app-custom-checkbox formControlName="swBreakdown" [labelText]="'Maneja Despiece'"
                  (onChangeCheckBox)="getSwBreakdown($event)"></app-custom-checkbox>
              </div>
              <div class="col-lg-10 col-md-12 col-sm-12 col-12">
                <div class="row d-flex align-items-center justify-content-end">
                  <div class="col-lg-2 col-md-4 col-sm-4 col-6">
                    <app-custom-tag [label]="'Vr.Total'" [severity]="'secondary'"
                      [value]="(formQuotationSolution.controls['totalValue'].value | number:'1.2-2') ?? '0.00'"></app-custom-tag>
                  </div>
                  <div class="col-lg-2 col-md-4 col-sm-4 col-6">
                    <app-custom-tag [label]="'Vr.Iva'" [severity]="'secondary'"
                      [value]="(formQuotationSolution.controls['ivaValue'].value | number:'1.2-2') ?? '0.00'"></app-custom-tag>
                  </div>
                  <div class="col-lg-2 col-md-4 col-sm-4 col-6">
                    <app-custom-tag [label]="'Total + Iva'"
                      [value]="(formQuotationSolution.controls['totalWithIva'].value | number:'1.2-2') ?? '0.00'"></app-custom-tag>
                  </div>
                </div>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-end align-items-end mt-2">
                <app-custom-button [label]="'Guardar'" [severity]="'primary'" [variant]="undefined" [width]="'5rem'"
                  [disabled]="!quotationVersionContract.active || quotationContract.quotationId === 0"
                  (onClick)="send()"></app-custom-button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div *ngIf="quotationSolutionContract.swBreakdown" class="container-style mt-2">
      <app-breakdown [quotationSolution]="quotationSolutionContract" [quotation]="quotationContract"
        [reloadList]="updateTableBreakdown" (breakdownsInSolution)="breakdownsInSolution = $event"
        [disableButtons]="!quotationVersionContract.active" [userAuthenticated]="userAuthenticated"
        (reloadSolution)="getQuotationDetailById()"></app-breakdown>
    </div>
  </div>